import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/ribeiro/Development/vertical-navbar-component-module/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Props, Playground } from 'docz';
import Navbar from './src/lib/';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h2 {...{
      "id": "introduction"
    }}>{`Introduction`}</h2>
    <p>{`Vertical Navbar is a react component that creates a
vertical navbar in the left side of the page.
It behaves completely responsive when accessing it in small devices
transforming the vertical navbar to a horizontal navbar at the bottom of the page.`}</p>
    <p><img alt="demogif" src={require("./src/lib/assets/demo.gif")} /></p>
    <h2 {...{
      "id": "props"
    }}>{`Props`}</h2>
    <Props of={Navbar} mdxType="Props" />
    <h2 {...{
      "id": "usage"
    }}>{`Usage`}</h2>
    <p>{`You may use this component as a wrapper of all (almost) your components.`}</p>
    <pre><code parentName="pre" {...{}}>{`import Navbar from '@redwallsolutions/vertical-navbar-component-module'
import mylogo from './assets/mylogo.png'
...
<App>
    <SomeStoreOrThemeProvider>
        <Navbar items={[]} logo={mylogo}>
            {/*All your application components here/*}
        </Navbar>
    </SomeStoreOrThemeProvider>
</App>
`}</code></pre>
    <br />
    <p><strong parentName="p">{`Passing some awesome icon`}</strong></p>
    <p>{`You can render anything in the `}<inlineCode parentName="p">{`icon`}</inlineCode>{` item prop attribute.
For example, using the `}<a parentName="p" {...{
        "href": "https://react-icons.netlify.com/#/"
      }}>{`react-icon`}</a>{` package or other awesome icon package of your taste:`}</p>
    <pre><code parentName="pre" {...{}}>{`import Navbar from '@redwallsolutions/vertical-navbar-component-module'
import {MdInsertChart} from 'react-icons/md'
...
<Navbar items={[name: 'Dashboard', icon: <MdInsertChart/>, handler:console.log]}>
    {/*All your application components here/*}
</Navbar>
`}</code></pre>
    <br />
    <p><strong parentName="p">{`Changing the appearance and theme`}</strong></p>
    <p>{`This component supports two additional props: `}<inlineCode parentName="p">{`appearance`}</inlineCode>{` and `}<inlineCode parentName="p">{`theme`}</inlineCode>{`.`}</p>
    <p>{`The `}<inlineCode parentName="p">{`appearance`}</inlineCode>{` can receive one of these three values: `}<inlineCode parentName="p">{`'default'`}</inlineCode>{`, `}<inlineCode parentName="p">{`'primary'`}</inlineCode>{` or `}<inlineCode parentName="p">{`'secondary'`}</inlineCode>{`.
Each one of these changes completety the appearance of the component.`}</p>
    <pre><code parentName="pre" {...{}}>{`<Navbar appearance="primary"></Navbar>
`}</code></pre>
    <p>{`The `}<inlineCode parentName="p">{`theme`}</inlineCode>{` can receive an object value with the following structure:`}</p>
    <pre><code parentName="pre" {...{}}>{`{
    mode: 'light' | 'dark',
    default?: 'any color string'
    primary?: 'any color string',
    secondary?: 'any color string',
    defaultContrast?: 'any color string',
    primaryContrast?: 'any color string',
    secondaryContrast?: 'any color string',
    defaultDark?: 'any color string',
    primaryDark?: 'any color string',
    secondaryDark?: 'any color string',
    defaultContrastDark?: 'any color string',
    primaryContrastDark?: 'any color string',
    secondaryContrastDark?: 'any color string'
}
`}</code></pre>
    <p>{`The best way to understand how these attrs work together is to passing a complete
theme object with some of your favorite colors and switching the theme mode between `}<inlineCode parentName="p">{`'light'`}</inlineCode>{`, `}<inlineCode parentName="p">{`'dark'`}</inlineCode>{`. To get better results,
switch also the `}<inlineCode parentName="p">{`appearance`}</inlineCode>{` prop between the three available values.`}</p>
    <pre><code parentName="pre" {...{}}>{`<Navbar 
  items={[{name:'Some Option', icon: <SomeIcon/>, handler: someHandler}]}
  appearance="default"
  theme={{
      mode: 'light',
      primary: 'red',
      secondary: 'blue',
      default: 'green',
      ...
  }}>
    <div>I'm a pretty div content</div>
</Navbar>
`}</code></pre>
    <h2 {...{
      "id": "hooks"
    }}>{`Hooks`}</h2>
    <p>{`This amazing react feature is also present in the `}<strong parentName="p">{`Vertical Navbar`}</strong>{` component.
The only requirement to use it is calling it in a component that are `}<strong parentName="p">{`children`}</strong>{` of the `}<strong parentName="p">{`Navbar`}</strong>{`.`}</p>
    <pre><code parentName="pre" {...{}}>{`import Navbar, {useVerticalNavbarController} from '@redwallsolutions/vertical-navbar-component-module'
...
const MyContent = () => {
    const navbar = useVerticalNavbarController() //this will work
    console.log(navbar)
    return (<div>I'm just a child</div>)
}

<Navbar>
    <MyContent/>
</Navbar>
`}</code></pre>
    <p>{`If you try to call the controller hook outside the component, it will be undefined. 😿`}</p>
    <pre><code parentName="pre" {...{}}>{`import Navbar, {useVerticalNavbarController} from '@redwallsolutions/vertical-navbar-component-module'
...
const App = () => {
    const navbar = useVerticalNavbarController() //this WON'T work
    return (
        <Navbar>
            ...
        </Navbar>
    )
}
`}</code></pre>
    <p><em parentName="p">{`What can I do with hooks?`}</em></p>
    <p>{`Hooks allow you to have access to Navbar Controller. This important object exposes to you some interesting methods.
What about to start a built-in loadingbar automatically with fluid animations?`}</p>
    <pre><code parentName="pre" {...{}}>{`const MyContent = () => {
    const navbar = useVerticalNavbarController()
    navbar.startLoading() //look at the top of the page
    return (<div>I'm just a child</div>)
}
`}</code></pre>
    <p>{`You can finish the loadingbar animation anytime.`}</p>
    <pre><code parentName="pre" {...{}}>{`navbar.finishLoading()
`}</code></pre>
    <p>{`What about to programmatically set an active item of Navbar?`}</p>
    <pre><code parentName="pre" {...{}}>{`const MyContent = () => {
    const navbar = useVerticalNavbarController()
    navbar.setActiveItem(2) //will set the second item as active
    return (<div>I'm just a child</div>)
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      